<template>
<div class="main my">
  <!-- 用户权限管理 -->
  <form class="model-box clear bcw" @submit.prevent="checkForm" v-cloak>
    <van-row class="tac ptw">
      <van-col span="10" offset="7">
        <upload-file
            :id="'avatar'"
            :img="postForm.avatar"
            @callBackImgUrl="getIdCardUrl"></upload-file>
        <div class="mtn mbm fs1 c9">(证件照)</div>
      </van-col>
    </van-row>
    <van-cell-group>
      <van-field v-model="postForm.realName" label="教练姓名" clearable placeholder="请输入" />
      <van-field v-model="postForm.price" label="课时单价" placeholder="请输入"><van-button slot="button" size="small" type="default" disabled>元</van-button></van-field>
      <van-cell
        title="教练职称"
        v-model="jobtitle"
        value="请选择"
        is-link
        @click="timePopupShow = true;"/>
      <van-field
        label="教练简介"
        v-model="postForm.desc"
        placeholder="请输入"
        type="textarea"
        rows="3"
        autosize/>
    </van-cell-group>
    <the-btnbar ref="TheBtnbar" text="保存" :loadSta="subSta" :delBtn="true" delTxt="删除教练" @del="deleteItem"></the-btnbar>
  </form>

  <!-- 弹出层 -->
  <van-popup v-model="timePopupShow" position="bottom">
    <van-picker :columns="columns" show-toolbar @cancel="onCancel" @confirm="onConfirm" />
  </van-popup>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import TheBtnbar from './components/TheBtnBar';
import UploadFile from '@/components/UploadFile';
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Toast,Dialog
} from 'vant';
Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Toast).use(Dialog);

export default {
  components: {
    TheBtnbar,UploadFile
  },
  filters: {
    titleFilter(status) {
      // 教练职称
      const statusMap = {
        assistant: '助教',
        junior: '初级教练',
        intermediate: '中级教练',
        senior: '高级教练'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      subSta:false, //提交时 按钮状态
      timePopupShow:false,
      jobtitle:'助教', //显示的职称名称
      columns:[
        {text:'助教',value:'assistant'},
        {text:'初级教练',value:'junior'},
        {text:'中级教练',value:'intermediate'},
        {text:'高级教练',value:'senior'},
      ],
      postForm:{
        coachId:this.$route.query.coachId,
        avatar:'',
        realName:'',
        desc:'',
        price:'',
        title:'assistant'  //职称
      }
    }
  },
  created(){
    // 获取详情
    this.$http.post('club_coach_manage/getInfo',{
      coachId: this.$route.query.coachId
    }).then(res => {
      // console.log(res)
      if (!res.data.code) {
        this.postForm.avatar = res.data.value.avatar
        this.postForm.realName = res.data.value.realName
        this.postForm.desc = res.data.value.desc
        this.postForm.price = res.data.value.price
        this.postForm.title = res.data.value.title
        // 监听职称显示名
        switch(res.data.value.title){
          case 'assistant': 
          this.jobtitle = '助教';break;
          case 'junior': 
          this.jobtitle = '初级教练';break;
          case 'intermediate': 
          this.jobtitle = '中级教练';break;
          case 'senior': 
          this.jobtitle = '高级教练';break;
        }
      } else {
        Toast.fail(res.data.message);
      }
    })
  },
  methods: {
    getIdCardUrl: function(url){
      // 证件照片
      this.postForm[url.name] = url.url;
    },
    onChange(picker, value, index) {
      // 选择职称
      // console.log(value)
      this.jobtitle = value.text
      this.postForm.title = value.value
      this.timePopupShow = false
    },
    onConfirm(value, index) {
      this.jobtitle = value.text
      this.postForm.title = value.value
      this.timePopupShow = false
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      // Toast('取消');
      this.timePopupShow = false
    },
    checkForm: function(){
      // console.log(this.postForm)

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))

      _this.subSta = true
      // 提交表单
      _this.$http.post('club_coach_manage/edit',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'编辑成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1)
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    },
    deleteItem(){
      // 删除
      let _this = this
      Dialog.confirm({
        title: '确认删除？'
      }).then(() => {
        // on confirm
        _this.$http.post('club_coach_manage/delete',{
          coachId: _this.$route.query.coachId
        }).then(function(res){
            if(res.data.code == 0){
              Toast.success({                
                message:'已删除！',
                duration:1000 
              })
              setTimeout(function(){
                _this.$router.go(-1)
              }, 1000) 
            }else{
              Toast(res.data.message)
            }
        })
      }).catch(() => {
        // on cancel
      });
      
    }
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/manage/CoachEdit.vue